"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
var action_1 = require("app/module/login/action");
var initialState = {};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case action_1.SET_TOKEN:
            return __assign(__assign({}, state), { token: action.payload.token });
        case action_1.GET_LOGIN_INFO:
            return __assign(__assign({}, state), action.payload.loginInfo);
        default:
            return state;
    }
}
exports.reducer = reducer;
